import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useState } from 'react';
function withDelay(Component) {
    return function ComponentWithDelay(props) {
        var _a = props.delay, delay = _a === void 0 ? 0 : _a, _b = props.placeholder, placeholder = _b === void 0 ? null : _b, rest = __rest(props, ["delay", "placeholder"]);
        var _c = __read(useState(delay === 0), 2), visible = _c[0], setVisible = _c[1];
        useEffect(function () {
            var timeout = !visible
                ? window.setTimeout(function () { return setVisible(true); }, delay)
                : undefined;
            return function () {
                if (timeout) {
                    clearTimeout(timeout);
                }
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return visible ? React.createElement(Component, __assign({}, rest)) : placeholder;
    };
}
export { withDelay };
